import { Link } from "react-router-dom";

export default function AboutHero() {
  return (
    <section className="pt-36 pb-0 px-8 md:px-16 max-w-screen-xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-end">
        {/* Left text */}
        <div className="lg:col-span-6 pb-16">
          <span
            className="inline-flex items-center gap-2 text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-8"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <span className="w-6 h-px bg-[#C8BAA8] inline-block" />
            Our Story
          </span>

          <h1
            className="text-[#2C2825] text-5xl md:text-6xl lg:text-[68px] leading-[1.05] mb-8"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            About Calm<br />
            <em>Spaces Journal</em>
          </h1>

          <p
            className="text-[#6B5E53] text-base leading-relaxed mb-6 max-w-md"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Calm Spaces Journal is a visual collection of peaceful interiors, cozy corners,
            and warm minimalist home inspiration — curated for people who want a softer,
            quieter home feeling.
          </p>

          <p
            className="text-[#8B8378] text-base leading-relaxed mb-12 max-w-md"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            We believe your home should feel like a pause from the world — not a performance.
            Every space we share is chosen for its quiet beauty, warm textures, and sense
            of everyday calm.
          </p>

          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/living-room"
              className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-8 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Explore the Journal
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs" />
              </span>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2.5 border border-[#C8BAA8] text-[#6B5E53] px-8 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Say Hello
            </Link>
          </div>

          {/* Stats */}
          <div className="flex items-center gap-10 mt-14 pt-10 border-t border-[#EDE6DA]">
            {[
              { num: "200+", label: "Spaces Curated" },
              { num: "2020", label: "Est." },
              { num: "6", label: "Categories" },
            ].map((s) => (
              <div key={s.label}>
                <p
                  className="text-[#2C2825] text-3xl leading-none"
                  style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
                >
                  {s.num}
                </p>
                <p
                  className="text-[#B5A898] text-[10px] tracking-widest mt-1.5 uppercase"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Right — tall image */}
        <div className="lg:col-span-6 relative hidden lg:block">
          <div className="rounded-t-2xl overflow-hidden aspect-[3/4] bg-[#F5F1E8]">
            <img
              src="https://public.readdy.ai/ai/img_res/bf165237b4fb4e375b173ac0ea194635.jpg"
              alt="About Calm Spaces Journal"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Floating quote card */}
          <div className="absolute bottom-8 -left-6 bg-[#FAF7F0] rounded-xl px-6 py-5 max-w-[210px]">
            <p
              className="text-[#2C2825] text-sm leading-relaxed italic"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              "A home should feel like a pause, not a performance."
            </p>
            <p
              className="text-[#B5A898] text-[9px] tracking-widest mt-2.5 uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              — Calm Spaces Journal
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
